import template from './index.html'
import controller from './controller'

export const vsName = 'machinesContractAdd'
export const vsNgType = 'directive'

MachineContractsAddGridDirective.$inject = []
export function MachineContractsAddGridDirective() {
  return {
    templateUrl: template,
    transclude: false,
    restrict: 'E',
    scope: {
      model: "="
    },
    controller: controller,
    controllerAs: 'ctrl',
    bindToController: true
  }
}